import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import authTheme from '../styles/authTheme';
var FormContainer = styled.div.withConfig({
  displayName: "FormContainer",
  componentId: "juor65-0"
})(["margin:0 auto;max-width:", ";position:relative;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'auth.container.maxWidth', authTheme.auth.container.maxWidth));
});
export default FormContainer;